import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { DELIVERY, COLLECTION } from "../../../constants";
import { updateBasket } from "../../../actions/basket";
import { useDeviceSize, DESKTOP } from "../../../assets/hooks/useDeviceSize";
import { ImgIcon } from "../../../assets";
import { delivery, collection } from "../../../assets/icons";

const typeDetails = {
	[DELIVERY]: "You'd like the shop to deliver to an address you choose.",
	[COLLECTION]: "You'll pick up at an agreed time from this shop's address."
}

export default function OrderTypeSelector() {

	const device = useDeviceSize();
	const dispatch = useDispatch();
	const {
		vendor,
		basket
	} = useSelector(state => ({
		vendor: state.vendor,
		basket: state.basket
	}));

	const collectionAllowed = Boolean(vendor.acceptCollection && vendor.collectionTimes && vendor.collectionTimes.length);
	const deliveryAllowed = Boolean(vendor.acceptDelivery && vendor.deliveryTimes && vendor.deliveryTimes.length)

	return <div className="orderTypeSelector">
		<div className="inner flexy">

			<div
				title={collectionAllowed ? "Collection" : "Not available."}
				className={[
					"orderType",
					"featureFont",
					"uppercase",
					basket.type === COLLECTION && "active",
					!collectionAllowed && "disabled"
				].filter(c => c).join(" ")}
				onClick={() => {
					if (collectionAllowed && basket.type !== COLLECTION)
						dispatch(updateBasket({ type: COLLECTION }))
				}}
			>
				<ImgIcon src={collection} size={30} style={{ cursor: "inherit" }} />
				<div>Collection</div>
			</div>

			<div
				title={deliveryAllowed ? "Delivery" : "Not available."}
				className={[
					"orderType",
					"featureFont",
					"uppercase",
					basket.type === DELIVERY && "active",
					!deliveryAllowed && "disabled"
				].filter(c => c).join(" ")}
				onClick={() => {
					if (deliveryAllowed && basket.type !== DELIVERY)
						dispatch(updateBasket({ type: DELIVERY }))
				}}
			>
				<ImgIcon src={delivery} size={30} style={{ cursor: "inherit" }} />
				<div>Delivery</div>
			</div>
		</div>
		<div className="details">
			{typeDetails[basket.type] || `${device === DESKTOP ? "Click" : "Tap"} a delivery option above.`}
		</div>
	</div>
}